<template>
  <div>
    <div class="homepage-hero">
      <img src="../assets/background/golden.jpg" alt="Smart Pet Blood Bank">
      <div class="red-filter"></div>
      <div class="content">
        <h1>“ เพราะช่วงเวลาที่ต้องการเลือด เป็นวินาที ที่ทรมานมาก ”</h1>
        <router-link :to="{ name: 'donation'}" class="btn btn-secondary cta">ร่วมบริจาคเลือด</router-link>

        <router-link :to="{ name: 'findBlood'}" class="btn btn-secondary cta">ต้องการเลือด</router-link>
      </div>
    </div>
    <section class="mission-section">
      <h2>Our Mission</h2>
      <p>สนับสนุนธนาคารเลือดสัตว์เลี้ยง ให้มีเลือดพร้อมใช้ อย่างเพียงพอ และมีประสิทธิภาพสูงสุด</p>
    </section>
    <summary-section/>
    <blood-distribution-section/>
    <hero-pet-section/>
    <lives-saved-section/>
    <find-blood-section/>
    <supporter-section/>
  </div>
</template>

<script>
import SummarySection from '@/components/home/SummarySection.vue'
import BloodDistributionSection from '@/components/home/BloodDistributionSection.vue'
import HeroPetSection from '@/components/home/HeroPetSection.vue'
import LivesSavedSection from '@/components/home/LivesSavedSection.vue'
import FindBloodSection from '@/components/home/FindBloodSection.vue'
import SupporterSection from '@/components/SupporterSection.vue'

export default {
  name: 'Home',
  components: {
    SummarySection,
    BloodDistributionSection,
    HeroPetSection,
    LivesSavedSection,
    FindBloodSection,
    SupporterSection
  }
}
</script>

<style scoped lang="scss">
.homepage-hero {
  height: 22rem;
  overflow: hidden;
  position: relative;
  img {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
  .red-filter {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: $primary-dark;
    opacity: 0.5;
  }
  .content {
    position: absolute;
    padding: 1rem;
    top: 0;
    width: 100%;
    margin-top: 8rem;
    color: white;
    text-align: center;
    h1 {
      font-size: $h3-font-size;
    }
    .cta {
      margin-top: 1rem;
      padding: 0.375rem 3rem;
      margin-left: 0.5rem;
      margin-right: 0.5rem;
    }
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .homepage-hero {
    height: 36rem;
    .content {
      margin-top: 16rem;
      h1 {
        font-size: $h1-font-size;
      }
    }
  }
}

.mission-section {
  padding: 2rem 0.5rem 2rem;
  h2 {
    text-align: center;
    color: $gray-600;
    font-size: $h6-font-size;
  }
  p {
    font-size: $h4-font-size;
    font-weight: $font-weight-light;
    max-width: 50rem;
    text-align: center;
    margin: auto;
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .mission-section {
    padding: 3rem 0 2rem;
    h2 {
      font-size: $h5-font-size;
    }
    p {
      font-size: $h1-font-size;
    }
  }
}
</style>
